/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {TriggerResource} from '../../components/api/resources/resource/trigger.resource';

@Component({
  standalone: false,
  selector: 'adn-trigger-route-page',
  template: `
    <adn-trigger-list-page
      *ngIf="list"
      [list]="list">
    </adn-trigger-list-page>
  `
})
export class TriggerRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(TriggerResource) private readonly Trigger: any
  ) {
  }

  ngOnInit(): void {
    this.adnListHelper.setUpList(this.list, this.Trigger, false, 'fullTriggerList', {
      baseTable: 'trigger'
    });
  }
}
